"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = require("@/api/systemConfig");
var _permission = require("@/utils/permission");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PackageReceiptSettings',
  data: function data() {
    return {
      status: null,
      loading: false,
      saving: false,
      error: ''
    };
  },
  computed: {
    canRead: function canRead() {
      return (0, _permission.checkPermi)(['platform:system:config:info']);
    },
    canSave: function canSave() {
      return this.canRead && (0, _permission.checkPermi)(['platform:system:config:save:form']);
    },
    mutationDisabled: function mutationDisabled() {
      return this.loading || this.saving || !this.status || !this.canSave || !this.status.configuredEnabled && !this.status.canEnable;
    },
    statusText: function statusText() {
      return this.status ? this.status.enabled ? '已开启' : '已关闭' : '状态未知';
    },
    notice: function notice() {
      if (!this.status) return '';
      if (!this.status.activationReady) {
        return this.status.reason && this.status.reason !== '待小程序正式发布' ? "\u5F85\u5C0F\u7A0B\u5E8F\u6B63\u5F0F\u53D1\u5E03\u3002".concat(this.status.reason) : '待小程序正式发布';
      }
      return this.status.reason || (this.status.canEnable ? '' : '功能准备中，暂时无法开启');
    }
  },
  mounted: function mounted() {
    this.loadStatus();
  },
  methods: {
    applyStatus: function applyStatus(data) {
      var fields = ['enabled', 'configuredEnabled', 'activationReady', 'storageReady', 'canEnable'];
      if (!data || !fields.every(function (field) {
        return typeof data[field] === 'boolean';
      }) || typeof data.reason !== 'string') {
        throw new Error('收货状态不完整');
      }
      this.status = data;
    },
    loadStatus: function () {
      var _loadStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!this.canRead || this.loading)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, false);
            case 1:
              this.loading = true;
              this.status = null;
              this.error = '';
              _context.p = 2;
              _t = this;
              _context.n = 3;
              return (0, _systemConfig.packageReceiptConfigInfoApi)();
            case 3:
              _t.applyStatus.call(_t, _context.v);
              return _context.a(2, true);
            case 4:
              _context.p = 4;
              _t2 = _context.v;
              this.error = '状态读取失败，请刷新后重试。';
              return _context.a(2, false);
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadStatus() {
        return _loadStatus.apply(this, arguments);
      }
      return loadStatus;
    }(),
    changeEnabled: function () {
      var _changeEnabled = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(enabled) {
        var _t3, _t4, _t5;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(typeof enabled !== 'boolean' || this.mutationDisabled || enabled === this.status.configuredEnabled || enabled && !this.status.canEnable)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.saving = true;
              _context2.p = 2;
              _context2.p = 3;
              _context2.n = 4;
              return this.$confirm(enabled ? '开启后，符合条件的订单可以按包裹确认收货，是否继续？' : '关闭后，未进入包裹收货流程的订单不再启用；已进入的订单仍可继续收货，记录保留，是否继续？', '包裹确认收货', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t3 = _context2.v;
              return _context2.a(2);
            case 6:
              if (!(!this.canRead || !this.canSave || !this.status || enabled && !this.status.canEnable)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              _t4 = this;
              _context2.n = 8;
              return (0, _systemConfig.packageReceiptConfigSaveApi)({
                enabled: enabled
              });
            case 8:
              _t4.applyStatus.call(_t4, _context2.v);
              _context2.n = 9;
              return this.loadStatus();
            case 9:
              if (!_context2.v) {
                _context2.n = 10;
                break;
              }
              if (this.status.enabled === enabled && this.status.configuredEnabled === enabled) {
                this.$message.success(enabled ? '包裹确认收货已开启' : '包裹确认收货已关闭');
              } else {
                this.$message.warning('已刷新实际状态，请查看当前状态及提示。');
              }
            case 10:
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t5 = _context2.v;
              this.status = null;
              this.error = '保存失败，当前状态未确认，请刷新后重试。';
            case 12:
              _context2.p = 12;
              this.saving = false;
              return _context2.f(12);
            case 13:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5], [2, 11, 12, 13]]);
      }));
      function changeEnabled(_x) {
        return _changeEnabled.apply(this, arguments);
      }
      return changeEnabled;
    }()
  }
};